import type { GridProps } from "@mui/material";
import type { FormGridProps } from "./types";

// form fields were rendered as <Grid item xs={12} sm={12} md={6} {...gridProps}> before MUI v7 - the v7 Grid takes the
// per-breakpoint widths in `size`, so keep the same defaults/overrides and pass any other grid props through
export const toGridItemProps = (gridProps: FormGridProps = {}): GridProps => {
  const { xs, sm, md, lg, xl, ...otherGridProps } = gridProps;

  return {
    ...otherGridProps,
    size: {
      xs: xs || 12,
      sm: sm || 12,
      md: md || 6,
      ...(lg !== undefined && { lg }),
      ...(xl !== undefined && { xl }),
    },
  };
};
